import { RouterView } from "vue-router";
import { META_HTML_TITLE } from "@core/constants";
import { ETAB_ROUTES } from "@etab/config";

import getAccountPages from "@etab/pages/account";
import getAuthPages from "@etab/pages/auth";
import getCandidateReferencePage from "@etab/pages/reference";
import getCreationPages from "@etab/pages/creation";
import getDashboardPages from "@etab/pages/dashboard";
import getPaymentPages from "@etab/pages/payment";
import getSignupPages from "@etab/pages/signup";
import getStartupPages from "@etab/pages/startup";
import getSubscriptionPages from "@etab/pages/subscription";
import getSuccessPage from "@etab/pages/success";
import getSurveyPages from "@etab/pages/survey";
import getUpfrontPage from "@etab/pages/upfront";
import getUserMenuPages from "@etab/pages/user-menu";

export default function () {
  return [
    {
      path: "/",
      component: RouterView,
      meta: { [META_HTML_TITLE]: "ETAB.PAGES.@APP_TITLE" },
      children: [
        ...getAccountPages(),
        ...getAuthPages(),
        ...getCandidateReferencePage(),
        ...getCreationPages(),
        ...getDashboardPages(),
        ...getPaymentPages(),
        ...getSignupPages(),
        ...getStartupPages(),
        ...getSubscriptionPages(),
        ...getSuccessPage(),
        ...getSurveyPages(),
        ...getUpfrontPage(),
        ...getUserMenuPages(),
      ],
    },
    {
      path: "/:catchAll(.*)", // 404 redirection
      redirect: { name: ETAB_ROUTES.auth.root.name },
    },
  ];
}
